module.exports = __webpack_public_path__ + "img/arrow-up.79d9c7d1.svg";